import { models } from './response-serialization'

export default definePayloadPlugin(() => {
    definePayloadReducer('model', getApiModelPayloadReducer())
    definePayloadReviver('model', getApiModelPayloadReviver(models))
})
